import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import getWacInfo from 'owa-attachment-wac/lib/services/getWacInfo';
import { getWacInfoPromiseOverride } from 'owa-groups-adaptors';
import { getHeaders } from 'owa-headers';
import WacAttachmentType from 'owa-service/lib/contract/WacAttachmentType';
import RequestOptions from 'owa-service/lib/RequestOptions';

const CLIENT_ACTION_NAME_PREFIX = 'GetWacInfo-FH-REACT-';

export default function getWacInfoForSharePointFile(
    url: string,
    providerType: AttachmentDataProviderType,
    actionSource: 'Prefetch' | 'Preview' | 'PreviewInNewSxS' | 'EditWacFile',
    isEdit?: boolean
): Promise<WacAttachmentType> {
    if (getWacInfoPromiseOverride) {
        return getWacInfoPromiseOverride(url, providerType, false)
            .then(response => response)
            .catch(() => {
                throw new Error('Getwacinfo failed.');
            });
    } else {
        const actionSourceString = CLIENT_ACTION_NAME_PREFIX + actionSource;
        const options: RequestOptions = {
            headers: getHeaders(null, actionSourceString),
            datapoint: {
                customData: {
                    actionSource: actionSourceString,
                },
                jsonCustomData: (json: WacAttachmentType) => {
                    let customData: { [index: string]: number | string | boolean | Date } = {};
                    if (json.Status) {
                        customData.wacUrlResponseStatus = json.Status.toString();
                    }
                    if (!json.WacUrl) {
                        customData.error = 'NoWacUrl';
                    }
                    return customData;
                },
            },
        };

        return getWacInfo(url, providerType, false, isEdit, options)
            .then(response => response)
            .catch(() => {
                throw new Error('Getwacinfo failed.');
            });
    }
}
